export const HOME_NET = 'home net'
